import { Box, Paper, styled } from "@mui/material"

export const Content = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("lg")]: {
    alignItems: "center",
    justifyContent: "center",
  },
  [theme.breakpoints.down("lg")]: {
    width: "100%",
  },
}))

export const Card = styled(Paper)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("lg")]: {
    backgroundColor: "transparent",
    minWidth: "530px",
  },
  [theme.breakpoints.down("lg")]: {
    backgroundColor: theme.palette.common.white,
    borderRadius: "36px",
    padding: "8px 16px 36px 16px",
    margin: "24px auto",
    width: "70%",
  },
  [theme.breakpoints.down("md")]: {
    width: "85%",
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
  },
}))
